import { render, staticRenderFns } from "./AddSekuritas.vue?vue&type=template&id=66cafd01&"
import script from "./AddSekuritas.vue?vue&type=script&lang=js&"
export * from "./AddSekuritas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports